import { Component, output, input, ChangeDetectionStrategy } from '@angular/core';

import type {
  ActivitySubscriptionType,
  ActivitySubscriptionEvent,
  ActivitySubscriptions,
  ActivitySubscriptionUpdateData,
} from '@core/activities-types';
import { trackByValue } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import type { IconName } from '@core/user-interface-legacy';
import { BadgeComponent, IconComponent } from '@core/user-interface-legacy';

import { ActivitySubscriptionsTableItemComponent } from './activity-subscriptions-table-item/activity-subscriptions-table-item.component';

@Component({
  selector: 'rt-activity-subscriptions-table-row',
  templateUrl: './activity-subscriptions-table-row.component.html',
  styleUrls: ['./activity-subscriptions-table-row.component.less'],
  host: { class: 'tr' },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconComponent, BadgeComponent, TranslatePipe, ActivitySubscriptionsTableItemComponent],
})
export class ActivitySubscriptionsTableRowComponent {
  public readonly title = input<string>(undefined!);
  public readonly icon = input<IconName>(undefined!);
  public readonly types = input<ActivitySubscriptionType[]>(undefined!);
  public readonly eventsGroup = input<ActivitySubscriptionEvent[]>(undefined!);
  public readonly activitySubscriptions = input<ActivitySubscriptions>(undefined!);
  public readonly notifyInfo = input<boolean>(undefined!);
  public readonly isNew = input<boolean>(false);
  public changeEvents = output<ActivitySubscriptionUpdateData>();

  public trackByType = trackByValue;
}
